<template>
  <button
    name="btn"
    class="back-button btn button"
    style="background-color: #ccc"
    v-on:click="onSubmit"
    type="button"
  >
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  props: { text: String },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      console.log("clicked");
      this.$emit("clicked");
    },
  },
};
</script>
<style>
.back-button {
  border-radius: 4px;
  border: none;
  background-color: #db9c94 !important;
  text-align: center;
  width: 125px !important;
  transition: all 0.5s;
  padding: 10px !important;
  margin: 5px 5 5 0;
}

.back-button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
  color: black;
}

.back-button span:before {
  content: "\00AB";
  position: absolute;
  opacity: 0;
  top: 0;
  left: -3px;
  transition: 0.5s;
  margin-right: 10px;
}

.back-button:hover span {
  padding-left: 25px;
}

.back-button:hover span:before {
  opacity: 1;
  left: 0;
}
</style>
